import { z } from 'zod';
/**
 * SKU Rules schema
 *
 * Global SKU parsing configuration used by backend and frontend.
 */
export const skuRulesSchema = z.object({
    standardGarments: z.array(z.string()).default([]),
    doubleSidedPrefixes: z.array(z.string()).default([]),
    firstTwoSegments: z.array(z.string()).default([]),
    wrapperTypes: z.array(z.string()).default([]),
    passThrough: z.array(z.string()).default([]),
});
